import type { PaintPerformanceIndex } from "../../models/admin-paint-scheme.models";

export const PERFORMANCE_INDEX_COLOR_CLASSES: Record<PaintPerformanceIndex, string> = {
  A0: "border-[#039746] bg-[#04AD51] text-black",
  A1: "border-[#76B43B] bg-[#91D053] text-black",
  A2: "border-[#B8D7AF] bg-[#E0F1DA] text-black",
  B1: "border-[#D89D00] bg-[#FDBF09] text-black",
  B2: "border-[#E6D59D] bg-[#FFF3CB] text-black",
  C1: "border-[#E66E6D] bg-[#FF8C8B] text-black",
  C2: "border-[#D00000] bg-[#FF0100] text-black",
  Unknown: "border-gray-300 bg-white text-gray-700 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-200",
};

export function getPerformanceIndexColorClasses(index: PaintPerformanceIndex): string {
  return PERFORMANCE_INDEX_COLOR_CLASSES[index];
}
